import { IonSpinner } from "@ionic/react";
import { GlobalContext } from "global/context/Provider";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { useContext, useEffect, useRef, useState } from "react";
import InputV1 from "_+_Portal/components/Genericos/InputV1/InputV1";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import {
  wsGetValidaOnlineToken,
  wsPostValidaOnline,
} from "_+_Portal/_-_Autocheckin/context/action/validaCobertura";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { proximoPaso } from "../PagesFun";
import {
  LeftContainer,
  MainContainer,
  Paso3Body,
  Paso3Container,
  Paso3ContainerBotones,
  Paso3ContainerBotonesSMG,
  Paso3SMGContainer,
  Paso3Titulo,
  RightContainer,
} from "./localStyle";
import ModalToken from "_+_Portal/_-_Autocheckin/components/genericos/ModalToken/ModalToken";
import { hideModal, showModal } from "global/context/action/modal/modal";
import {
  hideModalAlerta,
  showModalAlerta,
} from "global/context/action/modal/modalAlerta";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { wsGetTurnoByIdQr } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { showToaster } from "global/context/action/toaster/toaster";
import Keyboard from "_+_Portal/components/Genericos/Keyboard/Keyboard";
import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";

const ValidarCobertura = ({ turnoActual }) => {
  // -------------------------  context ----------------------------
  const {
    turnosSeleccionadosState,
    rutaState,
    pasoDispatch,
    rutaDispatch,
    puntoControlDispatch,
  } = useContext(AutocheckContext);

  const { authState, modalDispatch, toasterDispatch, modalAlertaDispatch } =
    useContext(GlobalContext);
  // -------------------------  context ----------------------------

  // -------------------------  useStates ----------------------------
  const [token, setToken] = useState({ token: "" });
  const [loading, setLoading] = useState(true);
  const [esSMG, setEsSMG] = useState(null);
  const [esAccord, setEsAccord] = useState(null);
  const [soloElegibilidad, setSoloElegibilidad] = useState(false);
  // pasoMixto: "C" = validando consulta, "P" = validando prácticas, null = no es mixto.
  // Se setea en el primer render según los flags del turno (ver más abajo).
  const [pasoMixto, setPasoMixto] = useState(null);
  // -------------------------  useStates ----------------------------

  // -------------------------  constantes ----------------------------
  const bodyTxt =
    "Ingresá el token o código de seguridad que figura en la aplicación de tu cobertura médica.";
  const bodyTxtSmg =
    "Le pedimos que nos indique si cuenta con la aplicación de la cobertura para usar el token de autorización o si tiene la credencial física";
  const titleTxtSmg = "Autorización de la cobertura";
  const bodyTxtAccord =
    "¿Cuenta con la aplicación de su cobertura para utilizar el token de seguridad?";
  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
  const turno = listTurnosSeleccionado[turnoActual];
  const paciente = authState?.auth?.data?.paciente;

  const intentos = useRef(0);
  // Aviso "doble token" se muestra solo en el primer render para turnos mixtos.
  const avisoMixtoMostrado = useRef(false);
  const titleTxtAccord = "Autorización de la cobertura";
  let idTerminal = getLocalStorage("idTerminal");

  // Detectar qué falta validar según los flags del backend (basados en VALIDAONLINE='1'
  // y POS_ESTADO != 'A'). Para OSDE típicamente la consulta es 420222 (no facturable)
  // que NO requiere validación → solo prácticas → 1 sola pantalla.
  const faltaC = !!turno?.faltaValidarConsulta;
  const faltaP = !!turno?.faltaValidarPracticas;
  const esMixto = faltaC && faltaP;
  const soloConsulta = faltaC && !faltaP;
  const soloPracticas = !faltaC && faltaP;

  // Textos dinámicos según el caso. En mixto incluyen "(N de 2)".
  const tituloPaso = esMixto
    ? pasoMixto === "P"
      ? "Validación (2 de 2)"
      : "Validación (1 de 2)"
    : soloPracticas
      ? "Validación de los estudios"
      : soloConsulta
        ? "Validación de la consulta"
        : null;
  const bodyTxtPaso = esMixto
    ? pasoMixto === "P"
      ? "Ingresá el token de seguridad para validar los estudios."
      : "Ingresá el token de seguridad para validar la consulta médica."
    : soloPracticas
      ? "Ingresá el token de seguridad para validar los estudios."
      : soloConsulta
        ? "Ingresá el token de seguridad para validar la consulta médica."
        : null;

  // -------------------------  constantes ----------------------------

  // -------------------------  funciones ----------------------------
  const handleClickVolver = () => {
    setPaso("TurnosDelDia")(pasoDispatch);
  };
  const dissmiss = () => {
    setLoading(false);
    hideModal()(modalDispatch);
  };

  const ingresarToken = (e) => {
    setToken({ token: e.target.value });
  };

  const handleKeyboardChange = (newValue) => {
    setToken({ token: newValue });
  };

  const nextStep = () => {
    if (typeof token.token === "string" && token.token.length > 0) {
      let dto = {};
      dto["tipoProceso"] = soloElegibilidad ? "1" : "2";
      dto["idTurno"] = turno?.idturno;
      dto["idPaciente"] = paciente?.codigo;
      dto["osToken"] = token.token;
      // Si el turno es mixto, mandamos qué subset validar en esta llamada
      // ("C" = solo consultas, "P" = solo prácticas). El backend filtra acorde.
      if (pasoMixto) {
        dto["tipoPrestacion"] = pasoMixto;
      }
      setLoading(true);
      wsPostValidaOnline([dto], finalizar);
    } else {
      showToaster(
        {
          texto: "Debes ingresar el token de tu cobertura para continuar.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };
  const updateTurno = (isCorrect, data) => {
    let pathUpdated = [];
    const ruta = rutaState.ruta.data;
    if (isCorrect) {
      // Solo avanzamos si SITEL aprobó (POS_ESTADO='A'). Cualquier otro
      // estado (R=rechazado, C=cancelado, null=sin procesar) debe ir a
      // PuntoControl — evita presente fake sobre validaciones no aprobadas.
      const estadoValidacion = data?.resumen?.validaOnlineEstado;
      if (estadoValidacion !== "A") {
        console.error(
          "[CheckinQR] updateTurno: validación online no aprobada",
          {
            idTurno: turno?.idturno,
            validaOnlineEstado: estadoValidacion,
          },
        );
        const idTipoPuntoControl = 9;
        setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
        setPaso("PuntoControl")(pasoDispatch);
        return;
      }
      if (data?.resumen?.monto) {
        pathUpdated.push("AbonarMP");
      }
      pathUpdated.push(ruta.pop());
      setRuta(proximoPaso(pathUpdated, setPaso, pasoDispatch))(rutaDispatch);
    } else {
      console.error("[CheckinQR] updateTurno falló post-validación", {
        idTurno: turno?.idturno,
        isCorrect,
      });
      const idTipoPuntoControl = 9;
      setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
      setPaso("PuntoControl")(pasoDispatch);
    }
  };
  const finalizar = (success, data) => {
    if (success && data?.success > 0) {
      // Caso mixto: si acabamos de validar la consulta (paso 1), antes de mostrar
      // la pantalla 2 (prácticas) refrescamos el turno. Si el WS POS ya autorizó
      // todas las prestaciones en la primera llamada, salteamos la pantalla 2
      // (sino le pediríamos al paciente un segundo token que no se va a verificar
      // realmente — el backend ya tiene todo en POS_ESTADO='A').
      if (esMixto && pasoMixto === "C") {
        setLoading("Verificando estado de validación...");
        wsGetTurnoByIdQr(turno?.idturno, (isCorrect, refreshedData) => {
          if (isCorrect && refreshedData?.resumen?.validaOnlineEstado === "A") {
            // Todo validado en la primera llamada → avanzar directamente.
            updateTurno(true, refreshedData);
            return;
          }
          // Validación incompleta → mostrar pantalla 2 con token nuevo.
          setToken({ token: "" });
          intentos.current = 0;
          setPasoMixto("P");
          setLoading(false);
        });
        return;
      }
      // Flujo normal: turno simple o ya completamos las dos pantallas del mixto.
      setLoading("Actualizando información de turno...");
      wsGetTurnoByIdQr(turno?.idturno, updateTurno);
    } else {
      if (intentos.current < 3) {
        intentos.current = intentos.current + 1;
        if (esSMG) {
          showToaster(
            {
              texto: "Ha ocurrido un error al intentar validar",
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
          setLoading(false);
        } else {
          showModal(
            <ModalToken dissmiss={dissmiss} mensaje={data?.mensaje} />,
            "Ups! Algo salió mal",
            dissmiss,
            false,
            {},
            "centro",
            true,
          )(modalDispatch);
        }
        setToken({ token: "" });
      } else {
        irPuntoDeControl();
      }
    }
  };

  const irPuntoDeControl = () => {
    setLoading(true);
    const idTipoPuntoControl = 9;
    setIdTipoPuntoControl(
      idTipoPuntoControl,
      "Superaste la cantidad de intentos permitidos para validar el token de tu cobertura.",
    )(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  const pedirToken = () => {
    setEsSMG(false);
  };

  const puntoControlAccord = () => {
    const idTipoPuntoControl = 9;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  const validarSinToken = () => {
    let dto = {};
    dto["tipoProceso"] = soloElegibilidad ? "1" : "2";
    dto["idTurno"] = turno?.idturno;
    dto["idPaciente"] = paciente?.codigo;
    // Si es mixto, también acá enviamos el subset para no validar todo de una.
    if (pasoMixto) {
      dto["tipoPrestacion"] = pasoMixto;
    }
    setLoading(true);
    wsPostValidaOnline([dto], finalizar);
  };

  // -------------------------  funciones ----------------------------

  // -------------------------  useEffect ----------------------------
  useEffect(() => {
    // Setear pasoMixto según los flags del backend (faltaValidarConsulta / faltaValidarPracticas):
    //   esMixto       → "C" (arranca por consulta, después pasa a "P")
    //   soloConsulta  → "C" (1 pantalla, valida solo consulta)
    //   soloPracticas → "P" (1 pantalla, valida solo prácticas)
    // Este valor se manda como tipoPrestacion al backend para filtrar qué validar.
    if (esMixto || soloConsulta) {
      setPasoMixto("C");
    } else if (soloPracticas) {
      setPasoMixto("P");
    }

    // Aviso "doble token" solo cuando el turno realmente requiere ambas validaciones.
    if (esMixto && !avisoMixtoMostrado.current) {
      avisoMixtoMostrado.current = true;
      showModal(
        <ModalAutoT
          dissmiss={dissmiss}
          desc={
            <p className="rb18l">
              Ingrese un primer token para continuar, luego se le solicitará un
              segundo token para completar su admisión
            </p>
          }
          title={"Información"}
          textBtnOne={"OK"}
          disableback={false}
          handleChange={{
            btnOne: () => {
              dissmiss();
            },
          }}
        />,
        "Información",
        dissmiss,
        false,
        {},
        "centro",
        true,
      )(modalDispatch);
    }

    let nextStep = (success, data) => {
      if (success && data.validaSoloElegibilidad) {
        setSoloElegibilidad(true);
      }
      if (success && data.token) {
        if (data.preguntarToken) {
          setEsSMG(data.preguntarToken);
          setEsAccord(data.preguntarToken);
        } else if (data.preguntarAppPaciente) {
          setEsSMG(data.preguntarAppPaciente);
        } else {
          setToken({ ...data, token: "" });
        }
        setLoading(false);
      } else if (success) {
        let dto = {};
        // tipoProceso: 1=Elegibilidad, 2=Autorización
        dto["tipoProceso"] = data.validaSoloElegibilidad ? "1" : "2";
        dto["idTurno"] = turno?.idturno;
        dto["idPaciente"] = paciente.codigo;
        wsPostValidaOnline([dto], finalizar);
      }
    };
    wsGetValidaOnlineToken(turno?.idturno, nextStep);
  }, []);
  // -------------------------  useEffect ----------------------------

  return (
    <LayoutPasos
      handleClick={handleClickVolver}
      volverTo={"/autocheckin/resumen"}
      type={"no-circle"}
      title={"Validación online"}
    >
      <CardBlueHeart
        medico={turno?.medico ? turno.medico : turno?.especialidad}
        turnoTitle={turno?.especialidad}
        pasoActual={turnoActual + 1}
        pasoTotal={listTurnosSeleccionado.length}
      />
      {loading ? (
        <Paso3Container>
          <span className={"spinner"}>
            <IonSpinner name="lines" />
          </span>
        </Paso3Container>
      ) : (
        <>
          {esSMG ? (
            <>
              <Paso3SMGContainer
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.4 }}
              >
                <Paso3Body>
                  <span className="rb22b ValidaTurnoSmg-titulo">
                    {esAccord ? titleTxtAccord : titleTxtSmg}
                  </span>
                </Paso3Body>
                <Paso3Body>
                  <span className="rb18l ValidaTurnoSmg-bodytxt">
                    {esAccord ? bodyTxtAccord : bodyTxtSmg}
                  </span>
                </Paso3Body>

                {esAccord ? (
                  <Paso3ContainerBotonesSMG>
                    <button
                      className="btn btn-validaturno bgc-primary c-white rb18m"
                      onClick={pedirToken}
                    >
                      SI
                    </button>
                    <button
                      className="btn btn-validaturno bgc-danger c-white rb18m"
                      onClick={puntoControlAccord}
                    >
                      NO
                    </button>
                  </Paso3ContainerBotonesSMG>
                ) : (
                  <Paso3ContainerBotonesSMG>
                    <button
                      className="btn btn-validaturno bgc-primary c-white rb18m"
                      onClick={pedirToken}
                    >
                      Aplicación de cobertura
                    </button>
                    <button
                      className="btn btn-validaturno bgc-primary c-white rb18m"
                      onClick={validarSinToken}
                    >
                      Credencial
                    </button>
                  </Paso3ContainerBotonesSMG>
                )}
              </Paso3SMGContainer>
            </>
          ) : (
            <Paso3Container
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 100 }}
              transition={{ duration: 0.4 }}
            >
              <PasoBar paso={"ValidarCobertura"} />
              <MainContainer>
                <LeftContainer $idTerminal={idTerminal}>
                  <Paso3Titulo>
                    <span className={`${idTerminal ? "rb32b" : "rb18m"}`}>
                      {tituloPaso ?? "Validación"}
                    </span>
                  </Paso3Titulo>
                  <hr className="ValidaTurno-separador"></hr>
                  <Paso3Body>
                    <span
                      className={`ValidaTurno-bodytxt ${idTerminal ? "rb24t" : "rb18m"}`}
                    >
                      {bodyTxtPaso ?? bodyTxt}
                    </span>
                    <div className="ValidaTurno-input">
                      <InputV1
                        clase="ValidaTurno-input"
                        placeholderText={"12254"}
                        onChange={ingresarToken}
                        inputType="number"
                        value={token.token}
                        className={"rb24t inputNonScroll"}
                      />
                    </div>
                  </Paso3Body>
                  <Paso3ContainerBotones>
                    {/* <button
                      className={`btn btn-validaturno bgc-danger c-white rb16m`}
                      onClick={irPuntoDeControl}
                    >
                      No lo tengo
                    </button> */}
                    <button
                      className={`btn btn-validaturno ${
                        token.token === "" || token.token === null
                          ? "bgc-grey65"
                          : "bgc-primary"
                      } c-white rb16m`}
                      onClick={nextStep}
                    >
                      Enviar
                    </button>
                  </Paso3ContainerBotones>
                </LeftContainer>
                {idTerminal && (
                  <RightContainer>
                    <Keyboard
                      value={token.token}
                      onChange={handleKeyboardChange}
                      onEnter={nextStep}
                      maxLength={8}
                      enterText="OK"
                      darkMode={true}
                    />
                  </RightContainer>
                )}
              </MainContainer>
            </Paso3Container>
          )}
        </>
      )}
    </LayoutPasos>
  );
};

export default ValidarCobertura;
